export default (function ($) {
	'use strict'

	var Filestyle = function (element, options) {
		this.options = options
		this.$elementFilestyle = []
		this.$element = $(element)
	}

	Filestyle.prototype = {
		clear: function () {
			this.$element.val('')
			this.$elementFilestyle.find(':text').val('')
		},

		destroy: function () {
			this.$element.removeAttr('style').removeData('filestyle').val('')
			this.$elementFilestyle.remove()
		},

		buttonText: function (value) {
			if (value !== undefined) {
				this.options.buttonText = value
				this.$elementFilestyle.find('label span').html(this.options.buttonText)
			} else {
				return this.options.buttonText
			}
		},

		pushNameFiles: function () {
			var content = '', files = []
			if (this.$element[0].files === undefined) {
				files[0] = {
					'name': this.$element[0] && this.$element[0].value
				}
			} else {
				files = this.$element[0].files
			}

			for (var i = 0; i < files.length; i++) {
				content += files[i].name.split('\\').pop() + ', '
			}

			if (content !== '') {
				this.$elementFilestyle.find(':text').val(content.replace(/\, $/g, ''))
			} else {
				this.$elementFilestyle.find(':text').val('')
			}

			return files
		},

		constructor: function () {
			var _self = this,
				html = '',
				id = _self.$element.attr('id'),
				files = [],
				btn = '',
				$label

			if (id === '' || !id) {
				id = 'filestyle-' + $('.bootstrap-filestyle').length
				_self.$element.attr({
					'id': id
				})
			}

			btn = '<span class="group-span-filestyle ' + 'input-group-btn' + '">' +
				'<label for="' + id + '" class="btn btn-default ' + 'btn-sm' + '" ' + '>' +
				'<span class="glyphicon glyphicon-folder-open"></span>' + _self.options.buttonText +
				'</label>' +
				'</span>'

			html = btn + '<input type="text" class="form-control input-sm" disabled>'

			_self.$elementFilestyle = $('<div class="bootstrap-filestyle input-group">' + html + '</div>')
			_self.$elementFilestyle.find('.group-span-filestyle').attr('tabindex', '0').keypress(function (e) {
				if (e.keyCode === 13 || e.charCode === 32) {
					_self.$elementFilestyle.find('label').click()
					return false
				}
			})

			_self.$element.css({
				'position': 'absolute',
				'clip': 'rect(0px 0px 0px 0px)'
			}).attr('tabindex', '-1').after(_self.$elementFilestyle)

			_self.$element.change(function () {
				_self.pushNameFiles()
			})

			if (window.navigator.userAgent.search(/firefox/i) > -1) {
				_self.$elementFilestyle.find('label').click(function () {
					_self.$element.click()
					return false
				})
			}
		}
	}

	var old = $.fn.filestyle

	$.fn.filestyle = function (option, value) {
		var get = '', element = this.each(function () {
			if ($(this).attr('type') === 'file') {
				var $this = $(this), data = $this.data('filestyle'),
					options = $.extend({}, $.fn.filestyle.defaults, option, typeof option === 'object' && option)

				if (!data) {
					$this.data('filestyle', (data = new Filestyle(this, options)))
					data.constructor()
				}

				if (typeof option === 'string') {
					get = data[option](value)
				}
			}
		})

		if (typeof get !== undefined) {
			return get
		} else {
			return element
		}
	}

	$.fn.filestyle.defaults = {
		'buttonText': 'Choose file'
	}

	$.fn.filestyle.noConflict = function () {
		$.fn.filestyle = old
		return this
	}

	$(function () {
		$('.filestyle').each(function () {
			var $this = $(this), options = {
				'buttonText': $this.attr('data-buttonText')
			}

			$this.filestyle(options)
		})
	})
})(window.jQuery)
